module.exports = __webpack_public_path__ + "static/drBahler-c7185ff3d7f888a1cd7ef6e08877cf35.png";